import { PagedSearch } from 'src/app/shared';

export class EventSubmissionSearch extends PagedSearch {
  SearchDateBegin?: string;
  SearchDateEnd?: string;
  OrderBy: string;
  IncludeProcessedRequests: boolean;
  MinimalData: boolean;

  constructor() {
    super();
    this.OrderBy = 'EventDate';
    this.IncludeProcessedRequests = false;
  }
}
